import gql from 'graphql-tag'

export const GET_MODULE_EVALUATION = gql`
  query avaliacaoCurso($modulo_id: String) {
    avaliacaoCurso(modulo_id: $modulo_id) {
      _id
      conteudo_id
      trilha_id
      curso_id
      usuarios
      conclusaoModulo
      perguntas {
        _id
        descricao
        tipoResposta
        alternativas
        obrigatorio
      }
      createdAt
    }
  }
`

export const GET_EVALUATION = gql`
  query avaliacao($conteudo_id: String!) {
    avaliacao(conteudo_id: $conteudo_id) {
      _id
      tipo
      usuario_id
      createdAt
    }
  }
`

export const GET_COMMENT = gql`
  query comentariosAvaliacao($conteudo_id: String!) {
    comentariosAvaliacao(conteudo_id: $conteudo_id) {
      _id
      descricao
    }
  }
`